import { createContext } from 'react';
import { useSavedFilters } from '../../../hooks/useSavedFilters';

export type SavedFiltersContextValue = ReturnType<typeof useSavedFilters>;

export const SavedFiltersContext = createContext<SavedFiltersContextValue | null>(null);
